(() => {
  const end = Date.parse('2027-01-01T05:00:00Z');
  const hideExpired = () => {
    if (Date.now() >= end) document.querySelectorAll('[data-holiday-promo]').forEach(el => { el.hidden = true; });
  };
  hideExpired();
  setInterval(hideExpired, 60000);
  const dock = document.querySelector('.cs-holiday-dock');
  if (dock && 'IntersectionObserver' in window) {
    const visible = new Set();
    dock.hidden = true;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      dock.hidden = visible.size > 0 || dock.dataset.dismissed === 'true' || Date.now() >= end;
    });
    document.querySelectorAll('.cs-holiday-banner,.cs-holiday-inline,[data-to-cart]').forEach(el => observer.observe(el));
  }
  document.addEventListener('click', event => {
    const apply = event.target.closest('[data-holiday-apply]');
    if (apply && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      if (apply.dataset.applying === 'true') return;
      apply.dataset.applying = 'true';
      const original = apply.textContent;
      apply.textContent = 'Applying HOLIDAY25…';
      apply.setAttribute('aria-busy', 'true');
      let notice = document.getElementById('cs-holiday-confirmation');
      if (!notice) {
        notice = document.createElement('div');
        notice.id = 'cs-holiday-confirmation';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        notice.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);width:min(440px,calc(100% - 32px));box-sizing:border-box;z-index:2147483000;padding:22px 48px 22px 22px;border-radius:16px;background:#123e74;color:white;border:2px solid #d9ff71;box-shadow:0 12px 48px #0005;font:inherit;line-height:1.5';
        const message = document.createElement('span');
        message.dataset.holidayConfirmationText = '';
        notice.append(message);
        const close = document.createElement('button');
        close.type = 'button';
        close.textContent = '×';
        close.setAttribute('aria-label', 'Close promotion confirmation');
        close.style.cssText = 'position:absolute;right:12px;top:10px;background:transparent;border:0;color:white;font-size:28px;cursor:pointer';
        close.addEventListener('click', () => { notice.hidden = true; });
        notice.append(close);
        document.body.append(notice);
      }
      notice.hidden = false;
      const message = notice.querySelector('[data-holiday-confirmation-text]');
      message.textContent = 'Applying your holiday discount…';
      fetch(apply.href, { credentials: 'same-origin' }).then(response => {
        if (!response.ok) throw new Error('Discount request failed');
        message.textContent = '✓ HOLIDAY25 applied! Your 25% discount will appear at checkout. Free expedited shipping is included.';
        document.querySelectorAll('[data-holiday-apply]').forEach(button => { button.textContent = '✓ HOLIDAY25 APPLIED'; });
      }).catch(() => {
        message.textContent = 'We couldn’t apply the code. Please try again or enter HOLIDAY25 at checkout.';
        apply.textContent = original;
      }).finally(() => {
        delete apply.dataset.applying;
        apply.removeAttribute('aria-busy');
      });
    }
    const pause = event.target.closest('[data-holiday-motion]');
    if (pause) {
      const banner = pause.closest('[data-holiday-promo]');
      const paused = banner.classList.toggle('cs-holiday-paused');
      pause.setAttribute('aria-pressed', String(paused));
      pause.textContent = paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel;
    }
    const dismiss = event.target.closest('[data-holiday-dismiss]');
    if (dismiss) {
      const panel = dismiss.closest('[data-holiday-promo]');
      panel.dataset.dismissed = 'true';
      panel.hidden = true;
    }
  });
})();
